
function OrbisBaseUXStyle() {
    return (
        <style>{`
            .grid-rows-pro,
            .affiliate-360,
            .permissions-pro,
            .settings-pro,
            .users-pro,
            .institution-pro,
            .orbis-base-pro {
                color: #f5fbff;
            }

            .grid-rows-pro table,
            .affiliate-360 table,
            .permissions-pro table,
            .users-pro table,
            .institution-pro table,
            .orbis-base-pro table {
                border-collapse: separate;
                border-spacing: 0;
                background: #061a2f;
            }

            .grid-rows-pro table tbody tr,
            .affiliate-360 table tbody tr,
            .permissions-pro table tbody tr,
            .users-pro table tbody tr,
            .institution-pro table tbody tr,
            .orbis-base-pro table tbody tr {
                transition: background .18s ease, box-shadow .18s ease;
                background: #08233d !important;
            }

            .grid-rows-pro table tbody tr:nth-child(even),
            .affiliate-360 table tbody tr:nth-child(even),
            .permissions-pro table tbody tr:nth-child(even),
            .users-pro table tbody tr:nth-child(even),
            .institution-pro table tbody tr:nth-child(even),
            .orbis-base-pro table tbody tr:nth-child(even) {
                background: #092a49 !important;
            }

            .grid-rows-pro table tbody tr:hover,
            .affiliate-360 table tbody tr:hover,
            .permissions-pro table tbody tr:hover,
            .users-pro table tbody tr:hover,
            .institution-pro table tbody tr:hover,
            .orbis-base-pro table tbody tr:hover {
                background: rgba(56,189,248,.075) !important;
                box-shadow: inset 3px 0 0 #d4af37;
            }

            .grid-rows-pro table tbody td,
            .affiliate-360 table tbody td,
            .permissions-pro table tbody td,
            .users-pro table tbody td,
            .institution-pro table tbody td,
            .orbis-base-pro table tbody td {
                border-top: 1px solid #24587c;
                background: transparent !important;
                color: #f5fbff !important;
            }

            .grid-rows-pro table thead th,
            .affiliate-360 table thead th,
            .permissions-pro table thead th,
            .users-pro table thead th,
            .institution-pro table thead th,
            .orbis-base-pro table thead th {
                position: sticky;
                top: 0;
                z-index: 10;
                background: #061a2f !important;
                color: #8fb9da !important;
                border-bottom: 1px solid #24587c;
                text-transform: uppercase;
                letter-spacing: .13em;
            }

            .grid-row-main,
            .row-main {
                color: #ffffff !important;
                font-weight: 700;
            }

            .grid-row-sub,
            .row-sub {
                color: #9fc4df !important;
                font-size: 12px;
            }

            .card,
            .orbis-card,
            .base-card,
            .module-card {
                border: 1px solid rgba(11,93,140,.82) !important;
                background: #04192b !important;
                color: #f5fbff !important;
                box-shadow: 0 12px 30px rgba(0,0,0,.24) !important;
            }

            .card-title,
            .section-title {
                color: #ffffff !important;
            }

            .card-header-inline,
            .orbis-card-head,
            .base-card-head {
                border-bottom: 1px solid #0b4d78 !important;
                background: #031425 !important;
            }

            input,
            select,
            textarea {
                border-color: #0b5f91 !important;
                background: #0b2740 !important;
                color: #ffffff !important;
            }

            input::placeholder,
            textarea::placeholder {
                color: #7ea8c7 !important;
            }

            input:focus,
            select:focus,
            textarea:focus {
                border-color: #d4af37 !important;
                box-shadow: 0 0 0 2px rgba(212,175,55,.18) !important;
                outline: none !important;
            }

            select option {
                background: #061a2f;
                color: #ffffff;
            }

            label {
                color: #8fb9da !important;
            }

            .btn,
            .orbis-btn,
            .base-btn {
                border: 1px solid #24537a !important;
                background: #0b2740 !important;
                color: #f5fbff !important;
                border-radius: 999px !important;
                font-weight: 700 !important;
            }

            .btn:hover,
            .orbis-btn:hover,
            .base-btn:hover {
                background: #10324f !important;
                border-color: #d4af37 !important;
            }

            .btn-primary,
            .bg-[#d4af37] {
                background: #d4af37 !important;
                color: #081a2b !important;
                border-color: #d4af37 !important;
            }

            .badge,
            .orbis-badge {
                border: 1px solid #24537a !important;
                background: #0f2d48 !important;
                color: #d9e8f5 !important;
            }

            .scroll-shell {
                border-color: #24587c !important;
                background: #04192b !important;
            }

            .top-scroll,
            .bottom-scroll,
            .max-h-\\[70vh\\],
            .overflow-x-auto,
            .overflow-auto {
                scrollbar-color: #2b638e #061a2f;
            }

            .top-scroll::-webkit-scrollbar,
            .bottom-scroll::-webkit-scrollbar,
            .overflow-x-auto::-webkit-scrollbar,
            .overflow-auto::-webkit-scrollbar {
                height: 10px;
                width: 10px;
            }

            .top-scroll::-webkit-scrollbar-track,
            .bottom-scroll::-webkit-scrollbar-track,
            .overflow-x-auto::-webkit-scrollbar-track,
            .overflow-auto::-webkit-scrollbar-track {
                background: #061a2f;
                border-radius: 999px;
            }

            .top-scroll::-webkit-scrollbar-thumb,
            .bottom-scroll::-webkit-scrollbar-thumb,
            .overflow-x-auto::-webkit-scrollbar-thumb,
            .overflow-auto::-webkit-scrollbar-thumb {
                background: #2b638e;
                border-radius: 999px;
            }

            .top-scroll::-webkit-scrollbar-thumb:hover,
            .bottom-scroll::-webkit-scrollbar-thumb:hover,
            .overflow-x-auto::-webkit-scrollbar-thumb:hover,
            .overflow-auto::-webkit-scrollbar-thumb:hover {
                background: #d4af37;
            }

            .avatar,
            .avatar-fallback {
                border-color: #0b5f91 !important;
                background: #0b2740 !important;
                color: #d9f4ff !important;
            }

            .alert-info {
                border: 1px solid #0ea5e9 !important;
                background: #0b2740 !important;
                color: #d9f4ff !important;
            }

            .permissions-page-pro {
                background:#041426 !important;
                color:#f5fbff !important;
            }

            .permissions-page-pro .permissions-hero {
                background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%) !important;
                border:1px solid rgba(11,93,140,.8) !important;
                box-shadow:0 20px 45px rgba(0,0,0,.28) !important;
                border-radius:28px !important;
                padding:28px !important;
            }

            .permissions-page-pro table {
                border-collapse:separate !important;
                border-spacing:0 !important;
                background:#061a2f !important;
            }

            .permissions-page-pro table thead,
            .permissions-page-pro table thead tr,
            .permissions-page-pro table thead th,
            .permissions-page-pro .bg-[#0f2d48] {
                background:#061a2f !important;
                color:#8fb9da !important;
            }

            .permissions-page-pro table thead th {
                position:sticky;
                top:0;
                z-index:10;
                border-bottom:1px solid #24587c !important;
                text-transform:uppercase;
                letter-spacing:.13em;
            }

            .permissions-page-pro table tbody tr {
                background:#08233d !important;
                transition:background .18s ease, box-shadow .18s ease;
            }

            .permissions-page-pro table tbody tr:nth-child(even) {
                background:#092a49 !important;
            }

            .permissions-page-pro table tbody tr:hover {
                background:rgba(56,189,248,.075) !important;
                box-shadow:inset 3px 0 0 #d4af37 !important;
            }

            .permissions-page-pro table tbody tr:hover td,
            .permissions-page-pro table tbody td {
                background:transparent !important;
                color:#f5fbff !important;
                border-top:1px solid #24587c !important;
            }

            .permissions-page-pro .divide-y > :not([hidden]) ~ :not([hidden]) {
                border-color:#24587c !important;
            }

            .permissions-page-pro input,
            .permissions-page-pro select,
            .permissions-page-pro textarea {
                background:#0b2740 !important;
                color:#fff !important;
                border:1px solid #0b5f91 !important;
                border-radius:12px !important;
            }

            .permissions-page-pro input::placeholder,
            .permissions-page-pro textarea::placeholder {
                color:#7ea8c7 !important;
            }

            .permissions-page-pro input:focus,
            .permissions-page-pro select:focus,
            .permissions-page-pro textarea:focus {
                border-color:#d4af37 !important;
                box-shadow:0 0 0 2px rgba(212,175,55,.18) !important;
                outline:none !important;
            }

            .permissions-page-pro select option {
                background:#061a2f !important;
                color:#fff !important;
            }

            .permissions-page-pro .bg-white,
            .permissions-page-pro .bg-gray-50,
            .permissions-page-pro .bg-[#0f2d48] {
                background:#04192b !important;
                color:#f5fbff !important;
            }

            .permissions-page-pro .hover\:bg-[#0f2d48]:hover,
            .permissions-page-pro .hover\:bg-gray-50:hover,
            .permissions-page-pro .hover\:bg-white:hover {
                background:#10324f !important;
            }

            .permissions-page-pro .btn,
            .permissions-page-pro button {
                border-radius:999px !important;
                font-weight:700 !important;
            }

            .permissions-page-pro .btn-secondary,
            .permissions-page-pro button:not(.btn-primary):not(.unstyled) {
                background:#0b2740 !important;
                border:1px solid #24537a !important;
                color:#f5fbff !important;
            }

            .permissions-page-pro .btn-secondary:hover,
            .permissions-page-pro button:not(.btn-primary):not(.unstyled):hover {
                background:#10324f !important;
                border-color:#d4af37 !important;
            }

            .permissions-page-pro .btn-primary,
            .permissions-page-pro .bg-[#d4af37] {
                background:#d4af37 !important;
                border-color:#d4af37 !important;
                color:#081a2b !important;
            }

            .permissions-page-pro .border-[#d4af37] {
                border-color:#d4af37 !important;
            }

            .permissions-page-pro .text-white {
                color:#fff !important;
            }

            .permissions-page-pro [style*="color: #111827"],
            .permissions-page-pro [style*="color:#111827"],
            .permissions-page-pro [style*="color: rgb(17, 24, 39)"] {
                color:#f5fbff !important;
            }

            .permissions-page-pro [style*="color: #6b7280"],
            .permissions-page-pro [style*="color:#6b7280"],
            .permissions-page-pro [style*="color: #666"],
            .permissions-page-pro [style*="color:#666"] {
                color:#9fc4df !important;
            }

            .permissions-page-pro code {
                color:#9fc4df !important;
                background:#0f2d48 !important;
                border:1px solid #24537a !important;
                border-radius:8px !important;
                padding:2px 5px !important;
            }

        `}</style>
    );
}

// src/pages/PermissionsPage.jsx
// ORBIS PMO — C2.8.4 Matriz cognitiva de permisos PRO
import React, { useEffect, useMemo, useState } from "react";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";



const ROLE_OPTIONS = [
    ["admin", "Administrador"],
    ["pm", "PM / Dirección de proyecto"],
    ["afiliaciones", "Afiliaciones"],
    ["solo_lectura", "Solo lectura"],
    ["sponsor", "Sponsor"],
    ["reviewer", "Revisor"],
    ["responsible", "Responsable"],
    ["stakeholder", "Stakeholder"],
];

const MODULE_TONES = {
    pmo: "bg-[#0b3552] text-[#7dd3fc] border-[#0ea5e9]/45",
    crm: "bg-[#0b3a36] text-[#7cebd0] border-[#10b981]/40",
    affiliations: "bg-[#24163d] text-[#c4b5fd] border-[#8b5cf6]/40",
    institution: "bg-[#3a3110] text-[#f6d76b] border-[#d4af37]/45",
    settings: "bg-[#0f2d48] text-[#d9e8f5] border-[#24537a]",
};

function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || localStorage.getItem("token") || "";
    return {
        ...extra,
        Authorization: token ? `Bearer ${token}` : "",
        "X-CANI-AUTH": token || "",
    };
}

async function safeJson(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();

    let data;
    try {
        data = JSON.parse(text);
    } catch {
        throw new Error(`Respuesta no JSON HTTP ${res.status}: ${text.slice(0, 180)}`);
    }

    if (!res.ok || data?.ok === false || data?.success === false) {
        throw new Error(data?.error || data?.detail || `HTTP ${res.status}`);
    }

    return data;
}

function normalizeList(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.filter(Boolean);
    if (typeof raw === "object") {
        return Object.entries(raw)
            .filter(([, value]) => Number(value) === 1 || value === true)
            .map(([key]) => key);
    }
    return [];
}

function readLocalPermissions() {
    try {
        return JSON.parse(localStorage.getItem("cani_permissions") || "[]");
    } catch {
        return [];
    }
}

function isAdminRole(role) {
    const r = String(role || "").toLowerCase();
    return r === "admin" || r === "administrador";
}

function Badge({ children, tone = "gray" }) {
    const tones = {
        gray: "bg-[#0f2d48] text-[#d9e8f5] border-[#24537a]",
        blue: "bg-[#0b3552] text-[#7dd3fc] border-[#0ea5e9]/45",
        green: "bg-[#0b3a36] text-[#7cebd0] border-[#10b981]/40",
        amber: "bg-[#3a3110] text-[#f6d76b] border-[#d4af37]/45",
        red: "bg-[#2b1117] text-[#fca5a5] border-[#ef4444]/40",
        purple: "bg-[#24163d] text-[#c4b5fd] border-[#8b5cf6]/40",
    };

    return (
        <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold ${tones[tone] || tones.gray}`}>
            {children}
        </span>
    );
}

function Toggle({ checked, onChange, disabled }) {
    return (
        <button
            type="button"
            disabled={disabled}
            onClick={() => !disabled && onChange(!checked)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${checked ? "bg-[#d4af37]" : "bg-[#0f2d48]"
                } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
            aria-pressed={checked}
        >
            <span
                className={`inline-block h-5 w-5 transform rounded-full bg-[#04192b] shadow transition ${checked ? "translate-x-5" : "translate-x-1"
                    }`}
            />
        </button>
    );
}

function EmptyState({ title, text }) {
    return (
        <div className="rounded-2xl border border-dashed border-[#24537a] bg-[#0f2d48] p-8 text-center">
            <div className="text-sm font-semibold text-[#d9e8f5]">{title}</div>
            <div className="mt-1 text-xs text-[#9fc4df]">{text}</div>
        </div>
    );
}

export default function PermissionsPage() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [toast, setToast] = useState(null);

    const [modules, setModules] = useState([]);
    const [catalog, setCatalog] = useState([]);
    const [rolePermissions, setRolePermissions] = useState({});
    const [users, setUsers] = useState([]);

    const [mode, setMode] = useState("user");
    const [selectedUserId, setSelectedUserId] = useState("");
    const [selectedRole, setSelectedRole] = useState("pm");

    const [query, setQuery] = useState("");
    const [moduleFilter, setModuleFilter] = useState("all");
    const [view, setView] = useState("matrix");

    const currentRole = localStorage.getItem("role") || "";
    const localPerms = readLocalPermissions();
    const canManage = isAdminRole(currentRole) || localPerms.includes("permissions.manage");
    const canView = canManage || localPerms.includes("permissions.view");

    async function load() {
        try {
            setLoading(true);
            setToast(null);

            const data = await safeJson(`${API_BASE}/permissions_matrix_get.php`, {
                headers: authHeaders(),
            });

            setCatalog(data.catalog || []);
            setModules(data.modules || []);
            setRolePermissions(data.role_permissions || {});
            setUsers(data.users || []);

            if (!selectedUserId && data.users?.[0]?.id) {
                const currentUserId = localStorage.getItem("user_id");
                const currentExists = data.users.some((u) => String(u.id) === String(currentUserId));
                setSelectedUserId(currentExists ? String(currentUserId) : String(data.users[0].id));
            }
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        load();
    }, []);

    const selectedUser = useMemo(() => {
        return users.find((u) => String(u.id) === String(selectedUserId)) || null;
    }, [users, selectedUserId]);

    const activePermissions = useMemo(() => {
        if (mode === "role") {
            return new Set(rolePermissions?.[selectedRole] || []);
        }

        return new Set(normalizeList(selectedUser?.effective_permissions || []));
    }, [mode, rolePermissions, selectedRole, selectedUser]);

    const moduleStats = useMemo(() => {
        return modules.map((m) => {
            const total = m.permissions?.length || 0;
            const on = (m.permissions || []).filter((p) => activePermissions.has(p.permission_key)).length;
            return { ...m, total, on };
        });
    }, [modules, activePermissions]);

    const filteredModules = useMemo(() => {
        const q = query.trim().toLowerCase();

        return modules
            .filter((m) => moduleFilter === "all" || m.module_key === moduleFilter)
            .map((m) => ({
                ...m,
                permissions: (m.permissions || []).filter((p) => {
                    if (!q) return true;

                    const txt = [
                        p.permission_key,
                        p.permission_label,
                        p.description,
                        p.module_name,
                        p.module_key,
                    ].filter(Boolean).join(" ").toLowerCase();

                    return txt.includes(q);
                }),
            }))
            .filter((m) => (m.permissions || []).length > 0);
    }, [modules, moduleFilter, query]);

    const kpis = useMemo(() => {
        const total = catalog.length;
        const granted = activePermissions.size;
        const usersCount = users.length;
        const modulesCount = modules.length;
        const coverage = total > 0 ? Math.round((granted / total) * 100) : 0;

        return { total, granted, usersCount, modulesCount, coverage };
    }, [catalog, activePermissions, users, modules]);

    function setUserPermission(permissionKey, checked) {
        if (!selectedUser) return;

        setUsers((prev) =>
            prev.map((u) => {
                if (String(u.id) !== String(selectedUser.id)) return u;

                const set = new Set(normalizeList(u.effective_permissions || []));
                if (checked) set.add(permissionKey);
                else set.delete(permissionKey);

                return { ...u, effective_permissions: Array.from(set) };
            })
        );
    }

    function setRolePermission(permissionKey, checked) {
        if (selectedRole === "admin") return;

        setRolePermissions((prev) => {
            const set = new Set(prev?.[selectedRole] || []);
            if (checked) set.add(permissionKey);
            else set.delete(permissionKey);

            return { ...prev, [selectedRole]: Array.from(set) };
        });
    }

    function applyModule(moduleKey, checked) {
        const module = modules.find((m) => m.module_key === moduleKey);
        if (!module) return;

        for (const p of module.permissions || []) {
            if (mode === "user") setUserPermission(p.permission_key, checked);
            else setRolePermission(p.permission_key, checked);
        }
    }

    function applyPreset(type) {
        const keys = catalog.map((p) => p.permission_key);

        if (type === "clear") {
            if (mode === "user" && selectedUser) {
                setUsers((prev) =>
                    prev.map((u) =>
                        String(u.id) === String(selectedUser.id)
                            ? { ...u, effective_permissions: [] }
                            : u
                    )
                );
            } else if (mode === "role" && selectedRole !== "admin") {
                setRolePermissions((prev) => ({ ...prev, [selectedRole]: [] }));
            }
            return;
        }

        if (type === "read") {
            const readKeys = keys.filter((k) => k.endsWith(".view"));
            if (mode === "user" && selectedUser) {
                setUsers((prev) =>
                    prev.map((u) =>
                        String(u.id) === String(selectedUser.id)
                            ? { ...u, effective_permissions: readKeys }
                            : u
                    )
                );
            } else if (mode === "role" && selectedRole !== "admin") {
                setRolePermissions((prev) => ({ ...prev, [selectedRole]: readKeys }));
            }
            return;
        }

        if (type === "all") {
            if (mode === "user" && selectedUser) {
                setUsers((prev) =>
                    prev.map((u) =>
                        String(u.id) === String(selectedUser.id)
                            ? { ...u, effective_permissions: keys }
                            : u
                    )
                );
            } else if (mode === "role" && selectedRole !== "admin") {
                setRolePermissions((prev) => ({ ...prev, [selectedRole]: keys }));
            }
        }
    }

    async function save() {
        try {
            setSaving(true);

            if (mode === "role") {
                if (selectedRole === "admin") {
                    setToast({ type: "error", msg: "El rol admin conserva todos los permisos." });
                    return;
                }

                await safeJson(`${API_BASE}/permissions_role_update.php`, {
                    method: "POST",
                    headers: authHeaders({ "Content-Type": "application/json" }),
                    body: JSON.stringify({
                        role_key: selectedRole,
                        permissions: rolePermissions[selectedRole] || [],
                    }),
                });

                setToast({ type: "ok", msg: "Permisos del rol guardados." });
            } else {
                if (!selectedUser) return;

                const permissions = normalizeList(selectedUser.effective_permissions || []);

                await safeJson(`${API_BASE}/permissions_user_update.php`, {
                    method: "POST",
                    headers: authHeaders({ "Content-Type": "application/json" }),
                    body: JSON.stringify({
                        user_id: selectedUser.id,
                        permissions,
                    }),
                });

                if (String(selectedUser.id) === String(localStorage.getItem("user_id"))) {
                    localStorage.setItem("cani_permissions", JSON.stringify(permissions));
                    window.dispatchEvent(new Event("cani-permissions-updated"));
                }

                setToast({ type: "ok", msg: "Permisos del usuario guardados." });
            }

            await load();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setSaving(false);
        }
    }

    async function refreshMine() {
        try {
            const data = await safeJson(`${API_BASE}/permissions_my_permissions.php`, {
                headers: authHeaders(),
            });

            localStorage.setItem("cani_permissions", JSON.stringify(data.permissions || []));
            if (data.role) localStorage.setItem("role", data.role);
            window.dispatchEvent(new Event("cani-permissions-updated"));

            setToast({ type: "ok", msg: "Permisos locales actualizados." });
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    if (!canView) {
        return (
            <MainLayout>
                <OrbisBaseUXStyle />
                <div className="p-6">
                    <div className="rounded-2xl border border-[#ef4444]/40 bg-[#2b1117] p-4 text-sm text-[#fca5a5]">
                        No autorizado. Esta sección requiere permisos de administración.
                    </div>
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <OrbisBaseUXStyle />
            <div className="permissions-page-pro orbis-base-pro min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8 space-y-6">
                <div className="permissions-hero flex flex-col xl:flex-row xl:items-start xl:justify-between gap-4">
                    <div>
                        <div className="inline-flex items-center gap-2 rounded-full border border-[#0ea5e9]/45 bg-[#0b3552] px-3 py-1 text-xs font-semibold text-[#7dd3fc]">
                            Seguridad de plataforma · RBAC
                        </div>
                        <h1 className="mt-3 text-2xl font-semibold text-white">
                            Matriz cognitiva de permisos
                        </h1>
                        <p className="mt-1 max-w-3xl text-sm text-[#9fc4df]">
                            Administra accesos por rol o por usuario con lectura ejecutiva, módulos agrupados,
                            acciones masivas y una matriz clara de permisos.
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-2">
                        <button className="btn btn-secondary btn-small" onClick={refreshMine}>
                            Actualizar mis permisos
                        </button>
                        <button className="btn btn-secondary btn-small" onClick={load}>
                            Recargar
                        </button>
                        <button disabled={!canManage || saving} className="btn btn-primary btn-small" onClick={save}>
                            {saving ? "Guardando..." : "Guardar cambios"}
                        </button>
                    </div>
                </div>

                {toast ? (
                    <div className={`rounded-2xl border px-4 py-3 text-sm ${toast.type === "ok"
                        ? "border-[#10b981]/40 bg-[#0b3a36] text-[#7cebd0]"
                        : "border-[#ef4444]/40 bg-[#2b1117] text-[#fca5a5]"
                        }`}>
                        {toast.msg}
                    </div>
                ) : null}

                <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
                    {[
                        ["Permisos", kpis.total, "Catálogo total"],
                        ["Activos", kpis.granted, `${kpis.coverage}% cobertura`],
                        ["Módulos", kpis.modulesCount, "Áreas controladas"],
                        ["Usuarios", kpis.usersCount, "Cuentas activas"],
                        ["Modo", mode === "user" ? "Usuario" : "Rol", mode === "user" ? selectedUser?.display_name || "—" : selectedRole],
                    ].map(([label, value, sub]) => (
                        <div key={label} className="rounded-2xl border border-[#0b4d78] bg-[#04192b] p-4 shadow-sm">
                            <div className="text-[11px] font-semibold text-[#9fc4df]">{label}</div>
                            <div className="mt-1 text-2xl font-bold text-white">{value}</div>
                            <div className="mt-1 text-[11px] text-[#8fb9da]">{sub}</div>
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-[320px_1fr] gap-4">
                    <aside className="space-y-4">
                        <div className="rounded-2xl border border-[#0b4d78] bg-[#04192b] p-4 shadow-sm">
                            <div className="text-sm font-semibold text-white">Objeto de permisos</div>
                            <div className="mt-3 grid grid-cols-2 gap-2">
                                <button
                                    className={`rounded-xl border px-3 py-2 text-xs font-semibold ${mode === "user" ? "bg-[#d4af37] text-white border-[#d4af37]" : "bg-[#0b2740] text-[#f5fbff] border-[#0b4d78]"}`}
                                    onClick={() => setMode("user")}
                                >
                                    Usuario
                                </button>
                                <button
                                    className={`rounded-xl border px-3 py-2 text-xs font-semibold ${mode === "role" ? "bg-[#d4af37] text-white border-[#d4af37]" : "bg-[#0b2740] text-[#f5fbff] border-[#0b4d78]"}`}
                                    onClick={() => setMode("role")}
                                >
                                    Rol
                                </button>
                            </div>

                            {mode === "user" ? (
                                <label className="mt-4 block">
                                    <span className="text-xs font-semibold text-[#9fc4df]">Usuario</span>
                                    <select
                                        value={selectedUserId}
                                        onChange={(e) => setSelectedUserId(e.target.value)}
                                        className="mt-1 w-full rounded-xl border border-[#0b4d78] px-3 py-2 text-sm"
                                    >
                                        {users.map((u) => (
                                            <option key={u.id} value={String(u.id)}>
                                                {u.display_name || u.email} · {String(u.role || "pm").toUpperCase()}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            ) : (
                                <label className="mt-4 block">
                                    <span className="text-xs font-semibold text-[#9fc4df]">Rol</span>
                                    <select
                                        value={selectedRole}
                                        onChange={(e) => setSelectedRole(e.target.value)}
                                        className="mt-1 w-full rounded-xl border border-[#0b4d78] px-3 py-2 text-sm"
                                    >
                                        {ROLE_OPTIONS.map(([key, label]) => (
                                            <option key={key} value={key}>{label}</option>
                                        ))}
                                    </select>
                                </label>
                            )}

                            <div className="mt-4 rounded-xl bg-[#0f2d48] p-3 text-xs text-[#9fc4df]">
                                {mode === "user"
                                    ? "Los permisos de usuario permiten excepciones específicas sobre el rol."
                                    : "Los permisos por rol definen la base para grupos de usuarios."}
                            </div>
                        </div>

                        <div className="rounded-2xl border border-[#0b4d78] bg-[#04192b] p-4 shadow-sm">
                            <div className="flex items-center justify-between gap-2">
                                <div className="text-sm font-semibold text-white">Módulos</div>
                                <Badge tone="blue">{moduleStats.length}</Badge>
                            </div>

                            <div className="mt-3 space-y-2">
                                <button
                                    className={`w-full rounded-xl border px-3 py-2 text-left text-xs ${moduleFilter === "all" ? "border-[#d4af37] bg-[#0b3552] text-[#7dd3fc]" : "border-[#0b4d78] bg-[#0b2740] text-[#f5fbff]"}`}
                                    onClick={() => setModuleFilter("all")}
                                >
                                    Todos los módulos
                                </button>

                                {moduleStats.map((m) => (
                                    <button
                                        key={m.module_key}
                                        className={`w-full rounded-xl border px-3 py-2 text-left ${moduleFilter === m.module_key ? "border-[#d4af37] bg-[#0b3552]" : "border-[#0b4d78] bg-[#04192b]"}`}
                                        onClick={() => setModuleFilter(m.module_key)}
                                    >
                                        <div className="flex items-center justify-between gap-2">
                                            <span className="text-xs font-semibold text-[#d9e8f5]">{m.module_name}</span>
                                            <span className="text-[11px] text-[#8fb9da]">{m.on}/{m.total}</span>
                                        </div>
                                        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-[#0f2d48]">
                                            <div
                                                className="h-full rounded-full bg-[#d4af37]"
                                                style={{ width: `${m.total ? Math.round((m.on / m.total) * 100) : 0}%` }}
                                            />
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </aside>

                    <section className="space-y-4">
                        <div className="rounded-2xl border border-[#0b4d78] bg-[#04192b] p-4 shadow-sm">
                            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                                <div>
                                    <div className="text-sm font-semibold text-white">Acciones de configuración</div>
                                    <div className="text-xs text-[#9fc4df]">Busca, filtra y aplica permisos por módulo o por preset.</div>
                                </div>

                                <div className="flex flex-wrap gap-2">
                                    <input
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        placeholder="Buscar permiso, módulo o clave..."
                                        className="min-w-[240px] rounded-xl border border-[#0b4d78] px-3 py-2 text-xs"
                                    />
                                    <button className={`btn btn-small ${view === "matrix" ? "btn-primary" : "btn-secondary"}`} onClick={() => setView("matrix")}>
                                        Matriz
                                    </button>
                                    <button className={`btn btn-small ${view === "cards" ? "btn-primary" : "btn-secondary"}`} onClick={() => setView("cards")}>
                                        Cards
                                    </button>
                                </div>
                            </div>

                            <div className="mt-4 flex flex-wrap gap-2">
                                <button disabled={!canManage} className="btn btn-secondary btn-small" onClick={() => applyPreset("read")}>
                                    Solo lectura
                                </button>
                                <button disabled={!canManage} className="btn btn-secondary btn-small" onClick={() => applyPreset("all")}>
                                    Permitir todo
                                </button>
                                <button disabled={!canManage} className="btn btn-secondary btn-small" onClick={() => applyPreset("clear")}>
                                    Limpiar
                                </button>
                            </div>
                        </div>

                        {loading ? (
                            <EmptyState title="Cargando matriz..." text="Estamos leyendo usuarios, roles y catálogo de permisos." />
                        ) : null}

                        {!loading && filteredModules.length === 0 ? (
                            <EmptyState title="Sin permisos para mostrar" text="Ajusta la búsqueda o el filtro de módulo." />
                        ) : null}

                        {!loading && view === "matrix" && filteredModules.length > 0 ? (
                            <div className="overflow-auto rounded-2xl border border-[#0b4d78] bg-[#04192b] shadow-sm">
                                <table className="w-full min-w-[940px] text-sm">
                                    <thead className="bg-[#0f2d48] text-left text-xs text-[#9fc4df]">
                                        <tr>
                                            <th className="px-4 py-3 w-[260px]">Módulo</th>
                                            <th className="px-4 py-3">Permiso</th>
                                            <th className="px-4 py-3 w-[240px]">Clave / descripción</th>
                                            <th className="px-4 py-3 w-[120px] text-center">Acceso</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-[#24587c]">
                                        {filteredModules.flatMap((m) =>
                                            (m.permissions || []).map((p, idx) => {
                                                const checked = activePermissions.has(p.permission_key);
                                                const disabled = !canManage || (mode === "role" && selectedRole === "admin");

                                                return (
                                                    <tr key={`${m.module_key}-${p.permission_key}`} className="hover:bg-[#0b3552]/40">
                                                        <td className="px-4 py-3 align-top">
                                                            {idx === 0 ? (
                                                                <div className="space-y-2">
                                                                    <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${MODULE_TONES[m.module_key] || MODULE_TONES.settings}`}>
                                                                        {m.module_name}
                                                                    </span>
                                                                    <div className="flex gap-1">
                                                                        <button
                                                                            disabled={!canManage}
                                                                            onClick={() => applyModule(m.module_key, true)}
                                                                            className="rounded-lg border border-[#0b4d78] px-2 py-1 text-[10px] text-[#9fc4df] hover:bg-[#0f2d48]"
                                                                        >
                                                                            Todo
                                                                        </button>
                                                                        <button
                                                                            disabled={!canManage}
                                                                            onClick={() => applyModule(m.module_key, false)}
                                                                            className="rounded-lg border border-[#0b4d78] px-2 py-1 text-[10px] text-[#9fc4df] hover:bg-[#0f2d48]"
                                                                        >
                                                                            Nada
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </td>
                                                        <td className="px-4 py-3 align-top">
                                                            <div className="font-semibold text-white">{p.permission_label}</div>
                                                            <div className="mt-1">
                                                                <Badge tone={checked ? "green" : "gray"}>
                                                                    {checked ? "Permitido" : "Sin acceso"}
                                                                </Badge>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3 align-top">
                                                            <code className="text-[11px] text-[#9fc4df]">{p.permission_key}</code>
                                                            <div className="mt-1 text-xs text-[#9fc4df]">{p.description || "—"}</div>
                                                        </td>
                                                        <td className="px-4 py-3 text-center align-top">
                                                            <Toggle
                                                                checked={checked}
                                                                disabled={disabled}
                                                                onChange={(next) => {
                                                                    if (mode === "user") setUserPermission(p.permission_key, next);
                                                                    else setRolePermission(p.permission_key, next);
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ) : null}

                        {!loading && view === "cards" && filteredModules.length > 0 ? (
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                {filteredModules.map((m) => (
                                    <div key={m.module_key} className="rounded-2xl border border-[#0b4d78] bg-[#04192b] p-4 shadow-sm">
                                        <div className="flex items-start justify-between gap-3">
                                            <div>
                                                <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${MODULE_TONES[m.module_key] || MODULE_TONES.settings}`}>
                                                    {m.module_name}
                                                </span>
                                                <div className="mt-1 text-xs text-[#9fc4df]">{m.module_key}</div>
                                            </div>
                                            <Badge tone="blue">{(m.permissions || []).length} permisos</Badge>
                                        </div>

                                        <div className="mt-4 divide-y divide-[#24587c]">
                                            {(m.permissions || []).map((p) => {
                                                const checked = activePermissions.has(p.permission_key);
                                                const disabled = !canManage || (mode === "role" && selectedRole === "admin");

                                                return (
                                                    <div key={p.permission_key} className="flex items-start justify-between gap-3 py-3">
                                                        <div>
                                                            <div className="text-sm font-semibold text-white">{p.permission_label}</div>
                                                            <div className="text-xs text-[#9fc4df]">{p.description || p.permission_key}</div>
                                                            <code className="text-[10px] text-[#8fb9da]">{p.permission_key}</code>
                                                        </div>
                                                        <Toggle
                                                            checked={checked}
                                                            disabled={disabled}
                                                            onChange={(next) => {
                                                                if (mode === "user") setUserPermission(p.permission_key, next);
                                                                else setRolePermission(p.permission_key, next);
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : null}
                    </section>
                </div>
            </div>
        </MainLayout>
    );
}
